import React  from 'react';
import {FieldViewProps} from "../../../render/view";

export default function FieldKeyboardShortcut_View(props:FieldViewProps) {

    const value = props.field.getViewValue(props.model)

    if (!value) return null

    return (
        <div className="ui5-keyboard-shortcut">
            <div className="ui5-ico-18 m-r-5 i5-keyboard"></div>
            <div className="shortcut-button">{value}</div>
        </div>

    )
}
